/* B2B intent forms (partner application, business quote) -> Thomas's backend, 2026-10-30.
   Spec: MYTHUMI_B2B表单接口文档_20261030.pdf. POST JSON to /apps/realizeit/b2b/partner-apply or
   /business-quote through the Shopify app proxy (same origin, signed by Shopify; only works on mythumi.com).

   Markup contract (see sections/b2b-biz-more.liquid, b2b-partner-more.liquid):
     <form data-b2b-intent data-endpoint="/apps/realizeit/b2b/..." data-page="business|partner" novalidate>
       inputs with data-api="contactName|email|company|phone|website|city|country|message|marketingConsent|nickname"
       inputs with data-extra="Readable label"   -> not in the API; appended to `message` as "Label: value" lines
       [data-b2b-status] (error box), [data-b2b-success] (hidden panel), [data-b2b-submit] (button)
   Responses: 201 ok, 400 field errors, 429 already received (shown as success), 501/5xx error -> retry. */
(function () {
  'use strict';

  var PROXY = '/apps/realizeit';
  var LIMITS = { contactName: 120, email: 254, company: 120, phone: 40, website: 300, city: 80, country: 60, message: 2000 };
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var WEB_RE = /^(https?:\/\/)?[^\s/?#.]+(\.[^\s/?#.]+)+([/?#]\S*)?$/i;

  function clean(v, max) {
    return String(v == null ? '' : v).replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, '').trim().slice(0, max || 2000);
  }

  // Same event shape as the creator's serverEvent (assets/ai3d-creator-page.js); no names, emails or companies in props.
  function serverEvent(name, props) {
    try {
      var session = null;
      try {
        session = sessionStorage.getItem('mythumi:analytics-session');
        if (!session) {
          session = Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
          sessionStorage.setItem('mythumi:analytics-session', session);
        }
      } catch (e) { session = null; }
      var token;
      try { token = localStorage.getItem('realizeit:visitor-token') || undefined; } catch (e) { token = undefined; }
      fetch(PROXY + '/events', {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name, jobId: null, session: session, page: location.pathname, visitorToken: token, props: props || {} })
      }).catch(function () {});
    } catch (e) { /* analytics must never break the form */ }
  }

  function friendly(reason) {
    var r = String(reason || '');
    if (r === 'required') return 'Please fill this in.';
    if (r === 'not an email address') return 'Enter an email like name@company.com.';
    if (r === 'not a web address') return 'Enter a web address like yourshop.com.';
    var m = r.match(/^at most (\d+) characters$/);
    if (m) return 'Keep it under ' + m[1] + ' characters.';
    return r || 'Please check this.';
  }

  function fieldBox(el) { return el.closest('.b2b-field') || el.closest('.b2b-fieldset') || el.parentNode; }

  function setFieldError(el, reason) {
    var box = fieldBox(el);
    if (!box) return;
    box.classList.add('is-invalid');
    el.setAttribute('aria-invalid', 'true');
    var msg = box.querySelector('.b2b-field-err');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'b2b-field-err';
      msg.id = (el.id || ('f' + Math.random().toString(36).slice(2))) + '-err';
      box.appendChild(msg);
      el.setAttribute('aria-describedby', msg.id);
    }
    msg.textContent = friendly(reason);
  }

  function clearErrors(form) {
    form.querySelectorAll('.is-invalid').forEach(function (b) { b.classList.remove('is-invalid'); });
    form.querySelectorAll('[aria-invalid]').forEach(function (e) { e.removeAttribute('aria-invalid'); });
    form.querySelectorAll('.b2b-field-err').forEach(function (m) { m.textContent = ''; });
  }

  function showStatus(form, text) {
    var box = form.querySelector('[data-b2b-status]');
    if (!box) return;
    box.textContent = text || '';
    box.hidden = !text;
  }

  function collect(form) {
    var data = {};
    var extras = [];
    form.querySelectorAll('[data-api]').forEach(function (el) {
      var key = el.getAttribute('data-api');
      if (key === 'marketingConsent') { data[key] = !!el.checked; return; }
      if (key === 'nickname') { data[key] = el.value || ''; return; }
      data[key] = clean(el.value, LIMITS[key]);
    });
    form.querySelectorAll('[data-extra]').forEach(function (el) {
      if (el.disabled) return; // e.g. the meeting fields while "I'd like a Google Meet" is unticked
      var v = clean(el.value, 200);
      if (v) extras.push(el.getAttribute('data-extra') + ': ' + v);
    });
    var params = new URLSearchParams(location.search);
    var ref = clean(params.get('ref'), 60);
    var camp = clean(params.get('utm_campaign') || params.get('utm_source'), 60);
    if (ref) extras.push('Reference: ' + ref);
    if (camp) extras.push('Campaign: ' + camp);
    if (extras.length) {
      var tail = '\n\n-- Details --\n' + extras.join('\n');
      var room = LIMITS.message - tail.length;
      data.message = (data.message || '').slice(0, Math.max(0, room)) + tail;
      data.message = data.message.replace(/^\s+/, '');
    }
    return data;
  }

  function validate(form, data) {
    var bad = {};
    form.querySelectorAll('[required]').forEach(function (el) {
      if (!clean(el.value)) bad[el.getAttribute('data-api') || el.id] = 'required';
    });
    if (data.email && !EMAIL_RE.test(data.email)) bad.email = 'not an email address';
    if (data.website && !WEB_RE.test(data.website)) bad.website = 'not a web address';
    Object.keys(LIMITS).forEach(function (k) {
      var el = form.querySelector('[data-api="' + k + '"]');
      if (el && k !== 'message' && clean(el.value, 100000).length > LIMITS[k]) bad[k] = 'at most ' + LIMITS[k] + ' characters';
    });
    return bad;
  }

  function markErrors(form, fields) {
    var first = null;
    Object.keys(fields).forEach(function (key) {
      var el = form.querySelector('[data-api="' + key + '"]') || form.querySelector('#' + CSS.escape(key));
      if (!el) return;
      setFieldError(el, fields[key]);
      if (!first) first = el;
    });
    if (first) first.focus();
  }

  /* Email copy of every request (Drew 2026-10-30: "同时发邮件"; the backend stores but sends no email).
     A hidden Shopify contact form (data-mail-form="<id>") emails the store inbox (official@mythumi.com).
     Shopify protects contact forms with hCaptcha: Shopify.captcha.protect(form) binds it, the captcha
     handler adds h-captcha-response on submit and then calls form.submit(), which is replaced here by a
     fetch so the page does not navigate (same recipe as the 2026-10-27 save-design test: 200 in ~3 s).
     If a native submit happens anyway it lands in a hidden iframe. Resolves true when the email was accepted. */
  function bindMail(mail) {
    if (!mail || mail.__b2bBound) return;
    mail.__b2bBound = true;
    try { if (window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === 'function') Shopify.captcha.protect(mail); } catch (e) {}
  }

  function sendMail(mail, data, saved) {
    return new Promise(function (resolve) {
      if (!mail) { resolve(false); return; }
      var settled = false;
      function finish(ok) { if (settled) return; settled = true; clearTimeout(timer); resolve(ok); }
      var timer = setTimeout(function () { finish(false); }, 25000);
      function put(name, value) { var el = mail.elements[name]; if (el) el.value = value == null ? '' : String(value); }
      put('contact[name]', data.contactName);
      put('contact[email]', data.email);
      put('contact[Company]', data.company);
      put('contact[Website]', data.website || '');
      put('contact[News consent]', data.marketingConsent ? 'Yes' : 'No');
      put('contact[Saved in backend]', saved);
      put('contact[body]', data.message || '');
      var sink = document.querySelector('iframe[name="b2b-mail-sink"]');
      if (sink) {
        mail.target = 'b2b-mail-sink';
        sink.addEventListener('load', function () { finish(true); }, { once: true });
      }
      mail.submit = function () {
        var token = mail.elements['h-captcha-response'];
        if (!token || !token.value) return; // the captcha handler calls again once it has a token
        fetch(mail.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(mail), credentials: 'same-origin' })
          .then(function (r) { finish(r.ok); }, function () { finish(false); });
      };
      bindMail(mail);
      try {
        if (typeof mail.requestSubmit === 'function') mail.requestSubmit();
        else mail.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      } catch (e) { finish(false); }
    });
  }

  function succeed(form, page, text) {
    var panel = form.querySelector('[data-b2b-success]');
    form.querySelectorAll('[data-b2b-body]').forEach(function (b) { b.hidden = true; });
    if (panel) {
      var p = panel.querySelector('[data-b2b-success-text]');
      if (p) {
        var wantsMeet = !!form.querySelector('[data-meet-toggle]:checked');
        var fallback = wantsMeet ? p.getAttribute('data-text-meet') : p.getAttribute('data-text-plain');
        p.textContent = text || fallback || p.textContent;
      }
      panel.hidden = false;
      panel.focus();
    }
  }

  function init(form) {
    var endpoint = form.getAttribute('data-endpoint');
    var page = form.getAttribute('data-page') || '';
    var button = form.querySelector('[data-b2b-submit]');
    var label = button ? button.textContent : '';
    var busy = false;
    var mail = document.getElementById(form.getAttribute('data-mail-form') || '');
    serverEvent('mythumi_b2b_page_view', { page: page });
    // Load the captcha only once someone starts filling the form, so it is ready by the time they send.
    form.addEventListener('focusin', function () { bindMail(mail); }, { once: true });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      clearErrors(form);
      showStatus(form, '');
      var data = collect(form);
      var bad = validate(form, data);
      if (Object.keys(bad).length) {
        markErrors(form, bad);
        showStatus(form, 'Please check the highlighted fields.');
        return;
      }
      busy = true;
      if (button) { button.disabled = true; button.textContent = 'Sending…'; }
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 20000) : null;
      fetch(PROXY + endpoint.replace(/^\/apps\/realizeit/, ''), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) { return { status: res.status, body: body || {} }; });
      }, function () {
        return { status: 0, body: {} };
      }).then(function (r) {
        if (timer) clearTimeout(timer);
        if (r.status === 400) {
          // Field errors: nothing was saved and no email goes out until they are fixed.
          busy = false;
          if (button) { button.disabled = false; button.textContent = label; }
          serverEvent('mythumi_b2b_form_error', { page: page, status: 400 });
          markErrors(form, r.body.fields || {});
          showStatus(form, r.body.error || 'Please check the highlighted fields.');
          return;
        }
        if (r.status !== 201) serverEvent('mythumi_b2b_form_error', { page: page, status: r.status });
        else serverEvent('mythumi_b2b_form_submit', { page: page });
        // A filled honeypot normally means a bot, and the backend then answers 201 without saving. The email copy
        // still goes out, flagged, so a real visitor whose browser filled the hidden field is not lost silently
        // (Drew 2026-10-30). Bots rarely get through the email form's own hCaptcha.
        var isBot = !!data.nickname;
        var saved = isBot ? 'No: hidden anti-bot field was filled, possible bot. Check by hand.'
          : (r.status === 201 ? 'Yes' : (r.status === 429 ? 'Already received today (429)' : 'No, error ' + (r.status || 'network')));
        var mailing = sendMail(mail, data, saved);
        return mailing.then(function (mailed) {
          busy = false;
          if (button) { button.disabled = false; button.textContent = label; }
          if (r.status === 201) {
            succeed(form, page);
          } else if (r.status === 429) {
            succeed(form, page, r.body.error || "We already have your request. We'll be in touch.");
          } else if (mailed) {
            // The backend failed but the email copy reached the inbox: the request is not lost.
            succeed(form, page);
          } else {
            showStatus(form, (r.body.error ? r.body.error + ' ' : 'Something went wrong on our side. ') + 'Please try again in a moment, or email official@mythumi.com.');
          }
        });
      });
    });
  }

  function start() { document.querySelectorAll('form[data-b2b-intent]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
